// The community home page writes "A people finding app for " itself, then
// the community's homePageTagline. A tagline saved with that phrase already
// at the start would read "A people finding app for A people finding app
// for…", so it's dropped here before display.
const PREFIX = /^\s*an?\s+people[- ]finding\s+app\s+for\s+/i;

export const taglineEnding = (tagline) => (tagline || '').replace(PREFIX, '');
